import React, { Component } from 'react'
import { render } from 'react-dom'

import { 
  LineChart,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts'

import '../../App.css'

import { InlineMath, BlockMath } from 'react-katex';

import {
  Container,
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

import * as ss from 'simple-statistics'

import Graph from './graph'

const gamma = require('gamma')

const nbd_m_init = 0.4125
const nbd_k_init = 0.09899


var get_nbd_list = function(m,k) {

  var array = []

  // mとkを明示的に数字にしないと、＋が文字列の連結になってしまう
  m = Number(m)
  k = Number(k)

  for(var r = 0; r < 100; r++){
    var value = (1 + m / k)**(-k) * gamma(k + r) * (m / (m + k))**r / gamma(r + 1) / gamma(k)
    if (value < 0.0001) {
      return array
    } else {
      array.push(value)
    }
    
    if (array.reduce((a,b) => a + b) > 0.99) {
      return array
    }
  }
  return array.filter((a) => a > 0.000001 )
}


class Nbd extends Component {

  constructor(props) {
    super(props);

    this.state = {
      m: nbd_m_init,
      k: nbd_k_init,
      vNbd: get_nbd_list(nbd_m_init,nbd_k_init).map((element) => Number(element.toFixed(3)))
    };
  }

  onNbdMChangeHandler = (event) => {
    if (event.target.value != "" && event.target.value != 0) {
      this.setState({ 
        m: event.target.value,
        k: this.state.k,
        vNbd: get_nbd_list(event.target.value,this.state.k).map((a) => Number(a.toFixed(3))),
      });
    } else {
      this.setState({ 
        m: nbd_m_init,
        k: this.state.k,
        vNbd: get_nbd_list(nbd_m_init,this.state.k).map((a) => Number(a.toFixed(3))),
      });
    }
  }

  onNbdKChangeHandler = (event) => {
    if (event.target.value != "" && event.target.value != 0) {
      this.setState({ 
        m: this.state.m,
        k: event.target.value,
        vNbd: get_nbd_list(this.state.m,event.target.value).map((a) => Number(a.toFixed(3))),
      });
    } else {
      this.setState({ 
        m: this.state.m,
        k: nbd_k_init,
        vNbd: get_nbd_list(this.state.m,nbd_k_init).map((a) => Number(a.toFixed(3))),
      });
    }
  }


  render() {

    var list = []
    if(this.state.m != "" && this.state.k != "") {
      if(this.state.vNbd.length != 0) {
        for(var i = 0; i < this.state.vNbd.length; i++){
          list.push(<tr><td className="td_01">{i}</td><td className="td_01">{this.state.m}</td><td className="td_01">{this.state.k}</td><td className="td_01">{(100 * this.state.vNbd[i]).toFixed(2)} % </td></tr>)
        }
      }
    }

    var nbd_data = [];
    if(this.state.m != "" && this.state.k != "") {
      if(this.state.vNbd.length != 0) {
        for(var i = 0; i < this.state.vNbd.length; i++){
          nbd_data.push({name: i, pdf: this.state.vNbd[i], cdf: this.state.vNbd.slice(0, i + 1).reduce((total, data) => {return (Number((total + data).toFixed(3))) < 1 ? Number((total + data).toFixed(3)) : 1})})
        }
      }
    }

    return (
      <div className="base">

        <Header as='h1'>
        負の二項分布
        </Header>
      
        <BlockMath>{`

        P\\left(r \\right | M, K) = \\frac{\\left(1 + \\frac{M}{K} \\right)^{-K} \\cdot \\Gamma\\left(K + r \\right)}{\\Gamma\\left(r + 1 \\right)\\cdot \\Gamma\\left(K \\right)} \\cdot \\left(\\frac{M}{M+K} \\right)^r \\cdots \\left(1 \\right)

       `}</BlockMath>

        <div style={{ textAlign: 'center' }}>
          <div>
            <Header as='h1'>
            input : <InlineMath>{`\\displaystyle M `}</InlineMath>
            <input onChange={this.onNbdMChangeHandler} style={{"margin-left":"20px"}}/>
            </Header>
            <Header as='h1'>
            input : <InlineMath>{`\\displaystyle K `}</InlineMath>
            <input onChange={this.onNbdKChangeHandler} style={{"margin-left":"20px"}}/>
            </Header>
          </div>
        </div>

        <Graph data={nbd_data}/>
        
        <table border="1" className="table_base">
            <tr>
              <th className="th_01"><InlineMath>{`\\displaystyle r `}</InlineMath></th>
              <th className="th_01"><InlineMath>{`\\displaystyle M `}</InlineMath></th>
              <th className="th_01"><InlineMath>{`\\displaystyle K `}</InlineMath></th>
              <th className="th_01"><InlineMath>{`\\displaystyle P \\left(r | M, K \\right)`}</InlineMath></th>
            </tr>
              {list}
        </table>

      </div>
    )   
  }
}

export default Nbd;
